/* PDP "Similar designs" carousel (Figma). Loaded from sections/main-product.liquid.
   Data source: middleware SKU-based similar-products API, same fetch logic as sections/close-match-pdp.liquid
   (that section is NOT placed in any template — this only reuses its technique, sharing window.kGetSimilarProducts
   so the two never double-fetch if close-match-pdp is ever re-enabled alongside this). UI/markup/scroll unchanged:
   real PLP cards (snippets/product-block.liquid) fetched per handle via sections/recently-view-card.liquid, same
   technique assets/pdp-explore.js uses. Markup: .pdp-similar under the trust block (hidden until filled). */
(function () {
  'use strict';
  var sec = document.querySelector('.pdp-similar');
  if (!sec) return;
  var track = sec.querySelector('.pdp-similar__track');
  var sku = String(sec.dataset.sku || '').trim();
  if (!sku || !track) return;
  var currentProductId = String(sec.dataset.productId || '').trim();
  var currentVariantId = String(sec.dataset.variantId || '').trim();
  var currentProductHandle = String(sec.dataset.productHandle || '').trim().toLowerCase();
  var apiBase = window.apiUrl || sec.dataset.apiBase;
  var LIMIT = 10;

  if (typeof window.kGetSimilarProducts !== 'function' && window.jQuery) {
    window.__kSimilarProductsRequests = window.__kSimilarProductsRequests || {};
    window.kGetSimilarProducts = function (value) {
      value = String(value || '').trim();
      if (!window.__kSimilarProductsRequests[value]) {
        window.__kSimilarProductsRequests[value] = jQuery.ajax({ url: apiBase + '/callback/similar-products', data: { sku: value }, type: 'GET', headers: { 'Content-Type': 'application/json' } });
      }
      return window.__kSimilarProductsRequests[value];
    };
  }
  var request = typeof window.kGetSimilarProducts === 'function'
    ? window.kGetSimilarProducts(sku)
    : fetch(apiBase + '/callback/similar-products?sku=' + encodeURIComponent(sku), { headers: { 'Content-Type': 'application/json' } });

  // Real PLP card for one product, via the Section Rendering API on the product's own URL —
  // sections/recently-view-card.liquid is just `{% render 'product-block', product: product %}`
  // (same technique Recently Viewed / Explore more / close-match-pdp use).
  var fetchCard = function (handle) {
    if (!handle) return Promise.resolve(null);
    return fetch('/products/' + encodeURIComponent(handle) + '?section_id=recently-view-card', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var node = html && new DOMParser().parseFromString(html, 'text/html').querySelector('.CT_product-block');
        if (!node) return null;
        var slide = document.createElement('div');
        slide.className = 'pdp-similar__slide';
        slide.appendChild(document.importNode(node, true));
        return slide;
      })
      .catch(function () { return null; });
  };

  request
    .then(function (response) { if (response && Array.isArray(response.product)) return response; if (!response.ok) throw new Error('Similar products request failed'); return response.json(); })
    .then(function (payload) {
      var products = Array.isArray(payload.product) ? payload.product.filter(function (p) {
        var pSku = String(p.sku || '').trim();
        var pHandle = String(p.handle || '').trim().toLowerCase();
        var pId = String(p.groupId || '').trim();
        var pVariantId = String(p.id || '').trim();
        return pSku !== sku && pHandle !== currentProductHandle && pId !== currentProductId && pVariantId !== currentVariantId;
      }).slice(0, LIMIT) : [];
      if (!products.length) return;
      return Promise.all(products.map(function (p) { return fetchCard(String(p.handle || '').trim()); })).then(function (slides) {
        slides.forEach(function (slide) { if (slide) track.appendChild(slide); });
        if (!track.children.length) return;
        var allLink = sec.querySelector('.pdp-similar__all');
        if (allLink) allLink.textContent = 'All ' + track.children.length;
        // Each PLP card has its own image swipe (KProductCardSlider); inside a horizontally scrolling carousel
        // that fights the carousel. Disable the per-card swipe here (dots still tap) so a swipe always scrolls
        // the carousel.
        Array.prototype.forEach.call(track.querySelectorAll('.card-image-wrap, [data-product-card-slider]'), function (n) {
          n.setAttribute('data-card-slider-disabled', 'true');
        });
        sec.classList.add('pdp-similar--cards');
        sec.hidden = false;
        if (window.KProductCardSlider && typeof window.KProductCardSlider.init === 'function') {
          window.KProductCardSlider.init(track);
        }
        if (typeof getLocalWishlistVariantIds === 'function' && typeof check_wishlist_added === 'function') {
          getLocalWishlistVariantIds().forEach(function (id) {
            check_wishlist_added(id);
          });
        }
      });
    })
    .catch(function (error) { console.warn('[Similar designs]', error); });
})();
